<p-panel class="secondary-panel">
  <ng-template pTemplate="header">
    <div class="d-flex justify-content-between align-items-center flex-fill">
      <span>Subject Property Information</span>
    </div>
  </ng-template>
  @if ({ info: propertyInfo$ | async }; as prop) {
    <div>
      <form [formGroup]="propertyForm">
        <div class="row">
          <div class="col-6 col-md-4 col-lg-3 col-xl-2 mt-3" [attr.automation-id]="'isPropertyAddressTBD' | qaSlug">
            <div class="checkbox-container">
              <p-checkbox
                id="isPropertyAddressTBD"
                name="isPropertyAddressTBD"
                [binary]="true"
                formControlName="isPropertyAddressTBD"
                [inputId]="'isPropertyAddressTBD' | qaSlug"
                (onChange)="updateTBDAddressFields(false)"
                labelStyleClass="bold-checkbox-label"
              />
              <label [for]="'isPropertyAddressTBD' | qaSlug">Property Address TBD</label>
            </div>
          </div>
          <div class="col-6 col-md-4 col-lg-3 col-xl-2 mt-3" [attr.automation-id]="'isSameAsPresentAddress' | qaSlug">
            <div class="checkbox-container">
              <p-checkbox
                id="isSameAsPresentAddress"
                name="isSameAsPresentAddress"
                [binary]="true"
                (onChange)="updateAddress(false)"
                formControlName="sameAsPresentAddress"
                [inputId]="'isSameAsPresentAddress' | qaSlug"
                labelStyleClass="bold-checkbox-label"
              />
              <label [for]="'isSameAsPresentAddress' | qaSlug">Same as Present Address</label>
            </div>
          </div>
          <div class="col-6 col-md-4 col-lg-3 col-xl-2 mt-3" [attr.automation-id]="'addressConfidentiality' | qaSlug">
            <div class="checkbox-container">
              <p-checkbox
                [binary]="true"
                formControlName="addressConfidentiality"
                [inputId]="'addressConfidentiality' | qaSlug"
                labelStyleClass="bold-checkbox-label"
              />
              <label [for]="'addressConfidentiality' | qaSlug">Address Confidentiality</label>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-6 col-md-4 col-lg-3 col-xl-2 mt-3" [attr.automation-id]="'propertyType' | qaSlug">
            <label for="propertyType" class="d-block control-label">Property Type <span class="color-danger">*</span></label>
            <p-select
              id="propertyType"
              [options]="lookups.propertyTypes"
              placeholder="Select"
              formControlName="propertyType"
              [optionLabel]="'name'"
              [optionValue]="'id'"
              styleClass="w-100"
              appendTo="body"
            />
            <cmg-validator-messages [control]="propertyForm.get('propertyType')" />
          </div>
          <div class="col-6 col-md-4 col-lg-3 col-xl-2 mt-3" [attr.automation-id]="'occupancyType' | qaSlug">
            <label for="occupancyType" class="d-block control-label">Occupancy Type <span class="color-danger">*</span></label>
            <p-select
              id="occupancyType"
              [options]="lookups.occupancyTypes"
              placeholder="Select"
              formControlName="occupancyType"
              [optionLabel]="'name'"
              [optionValue]="'id'"
              styleClass="w-100"
              appendTo="body"
            />
            <cmg-validator-messages [control]="propertyForm.get('occupancyType')" />
          </div>
        </div>
        <div class="row">
          <div class="col-lg-2 col-md-4 col-sm-4 col-xs-6 mt-2" [attr.automation-id]="'streetforUI' | qaSlug">
            <label for="streetforUI" class="control-label">Street Address <span class="color-danger">*</span></label>
            <input
              styleClass="form-control input-span"
              id="streetforUI"
              class="form-control"
              pInputText
              maxlength="50"
              formControlName="streetforUI"
            />
            <cmg-validator-messages [control]="propertyForm.get('streetforUI')" />
          </div>
          <div class="col-lg-2 col-md-4 col-sm-4 col-xs-6 mt-2" [attr.automation-id]="'zip' | qaSlug">
            <label for="zip" class="control-label">Zip Code <span class="color-danger">*</span></label>
            <cmg-form-control-zip-code id="zip" formControlName="zip" inputId="zip-input" />
            <cmg-validator-messages [control]="propertyForm.get('zip')" />
          </div>
          <div class="col-lg-2 col-md-4 col-sm-4 col-xs-6 mt-2" [attr.automation-id]="'state' | qaSlug">
            <label for="state" class="d-block control-label"
              >State
              @if (!propertyForm.get('isPropertyAddressTBD').value) {
                <span class="color-danger">*</span>
              }
            </label>
            <p-select
              id="state"
              [options]="lookups.states"
              placeholder="Select"
              formControlName="state"
              [optionLabel]="'name'"
              [optionValue]="'id'"
              styleClass="w-100"
              appendTo="body"
            />
          </div>
          <div class="col-lg-2 col-md-4 col-sm-4 col-xs-6 mt-2" [attr.automation-id]="'city' | qaSlug">
            <label for="city" class="control-label">City</label>
            <input id="city" class="form-control" pInputText maxlength="50" formControlName="city" />
          </div>
          <!-- State: Readonly -->
        </div>
        <div class="row">
          <div class="col-lg-2 col-md-4 col-sm-4 col-xs-6 mt-2" [attr.automation-id]="'county' | qaSlug">
            <label for="county" class="d-block control-label">County</label>
            <p-select
              id="county"
              [options]="lookups.counties"
              placeholder="Select"
              formControlName="county"
              [optionLabel]="'name'"
              [optionValue]="'name'"
              styleClass="w-100"
              appendTo="body"
            />
          </div>
          @if (showOccupancyType) {
            <div class="col-lg-2 col-md-4 col-sm-4 col-xs-6 mt-2">
              <label class="control-label">Gross Rent </label>
              <p-inputNumber
                id="grossRentalIncome"
                class="w-100"
                styleClass="form-control input-span"
                [minFractionDigits]="2"
                [maxFractionDigits]="2"
                [max]="99999999999.99"
                mode="currency"
                currency="USD"
                locale="en-US"
                maxlength="14"
                formControlName="grossRentalIncome"
                placeholder="$0.00"
              />
            </div>
          }
          @if (showOccupancyType) {
            <div class="col-lg-2 col-md-4 col-sm-4 col-xs-6 mt-2">
              <label class="control-label"> Vacancy Factor</label>
              <p-inputNumber
                class="w-100"
                id="vacancyFactor"
                styleClass="form-control input-span"
                formControlName="vacancyFactor"
                suffix="%"
                [minFractionDigits]="3"
                [maxFractionDigits]="3"
                cmgFormControlFactorReset
              />
            </div>
          }
          <div></div>
        </div>
      </form>
    </div>
  }
</p-panel>
